import { HsGeometryData } from './geometry-data.class';

/**
 * Handles s regular geometry data.
 */
export class HsRegularGeometryData extends HsGeometryData {}
